/**
 * 将输入值转换为数字。
 *
 * @category Type conversion
 *
 * @public
 *
 * @param value - 输入值。
 *
 * @returns 转换后的数字。
 */
export function number(value) {
    return Number(value);
}
//# sourceMappingURL=number.js.map